import { googleStartUrl } from "@/features/identity/identity.api";
import { trackSignupStarted } from "@/shared/analytics/registration-analytics";
import { rememberConsentReturnTo } from "@/shared/auth/oauth-return-to";
import { Button } from "@/shared/components/ui/button";

/**
 * "Continue with Google" CTA. Triggers a full-page navigation to the shore's
 * /auth/google/start endpoint, which sets the CSRF state cookie + 302-redirects
 * to Google's auth screen. We DON'T use `fetch` here because the OAuth flow is
 * pure redirect-based. A `returnTo` rides in the shore's signed state and
 * brings the person back to the AI app consent screen.
 */
export function ContinueWithGoogleButton({
  label,
  returnTo,
  trackRegistration = false,
}: {
  label: string;
  returnTo?: string;
  trackRegistration?: boolean;
}) {
  return (
    <Button
      type="button"
      variant="outline"
      className="w-full justify-center gap-3"
      onClick={() => {
        if (trackRegistration) trackSignupStarted("google");
        if (returnTo) rememberConsentReturnTo(returnTo);
        window.location.href = googleStartUrl(returnTo);
      }}
    >
      <GoogleMark />
      <span>{label}</span>
    </Button>
  );
}

// reason: Google brand guidelines mandate exact hex colors for the "G" logo.
const GOOGLE_BLUE = "#4285F4";
// reason: Google brand color (per above).
const GOOGLE_GREEN = "#34A853";
// reason: Google brand color (per above).
const GOOGLE_YELLOW = "#FBBC05";
// reason: Google brand color (per above).
const GOOGLE_RED = "#EA4335";

function GoogleMark() {
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden>
      <title>Google</title>
      <path
        fill={GOOGLE_BLUE}
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      />
      <path
        fill={GOOGLE_GREEN}
        d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.71H.957v2.332A8.997 8.997 0 009 18z"
      />
      <path
        fill={GOOGLE_YELLOW}
        d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
      />
      <path
        fill={GOOGLE_RED}
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
      />
    </svg>
  );
}
